
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"40.1","cy":"43.5","r":"20.8","stroke":"#9FFCEA","stroke-width":"6"}}),_c('circle',{attrs:{"cx":"20.86","cy":"57.87","r":"10.86","fill":"#38DFBF"}}),_c('circle',{attrs:{"cx":"59.14","cy":"57.87","r":"10.86","fill":"#38DFBF"}}),_c('circle',{attrs:{"cx":"39.76","cy":"22.86","r":"10.86","fill":"#38DFBF"}})])
          )
        }
      }
    